import { render, staticRenderFns } from "./PricingPlan.vue?vue&type=template&id=1931e710&"
import script from "./PricingPlan.vue?vue&type=script&lang=js&"
export * from "./PricingPlan.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlan.vue?vue&type=style&index=0&id=1931e710&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports